var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{
      name: 'industrial_admin_tank_report',
      query: { branchId: _vm.data.branchID },
    }}},[_c('button',[_vm._v("View Details")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }